import { render, staticRenderFns } from "./TimelinePermitListAdmin.vue?vue&type=template&id=20b4f20d&lang=pug&"
import script from "./TimelinePermitListAdmin.vue?vue&type=script&lang=js&"
export * from "./TimelinePermitListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports